module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "border": "0px solid red"
    }
  }, [_c('LeftMenu', {
    key: _vm.MenuKey,
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "flex": "1",
      "overflow-x": "hidden",
      "overflow-y": "auto"
    },
    attrs: {
      "menuData": _vm.lftMenu.menus,
      "menuAct": _vm.lftMenu.menuAct,
      "titleShow": _vm.lftMenu.show
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0874853a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/mainmenu.vue
// module id = 756
// module chunks = 1